import axiosHandler from '../axiosInterceptors.js';
import authConfig from '../authConfig.js';

const setAuthHeader = () => {
  const authority = authConfig.authority;
  const clientId = authConfig.client_id;
  const tokensInfo = sessionStorage.getItem('oidc.user:' + authority + ':' + clientId);
  const tokenObj = JSON.parse(tokensInfo);
  const access_token = tokenObj?.access_token;
  const id_token = tokenObj?.id_token
  axiosHandler.defaults.headers.common['Authorization'] = access_token ? `Bearer ${access_token}` : `Bearer ${id_token}`;
  axiosHandler.defaults.headers.common['Cache-Control'] = 'private, max-age=3600';
  axiosHandler.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
  axiosHandler.defaults.headers.common['Referrer-Policy'] = 'same-origin';
};


export default setAuthHeader;